export enum EnvironmentNames {
  Default = 'default',
  Develop = 'develop',
  Homolog = 'homolog',
  Production = 'production'
}